var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "card", style: _vm.cardStyle, attrs: { shadow: "hover" } },
    [
      _c(
        "div",
        { staticClass: "card-header-listagem" },
        [
          _c("h1", { staticClass: "titulo" }, [_vm._v(_vm._s(_vm.cardTitle))]),
          _vm.showBtnAction
            ? _c(
                "el-button",
                {
                  attrs: { type: _vm.btnType },
                  on: {
                    click: function($event) {
                      return _vm.$emit("execAction")
                    }
                  }
                },
                [
                  _c("i", { class: _vm.btnIconClass }),
                  _c("span", [_vm._v("  " + _vm._s(_vm.btnActionTitle))])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c("div", { staticClass: "card-body-listagem" }, [_vm._t("body")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ec5ca96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec5ca96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Cards/CardListagem/CardListagem.vue
// module id = null
// module chunks = 